export { Clock as default } from './Clock';
